// Disable form submission by hitting ENTER key
// https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event
const $forms = document.getElementsByTagName("form");

for (let i = 0; i < $forms.length; i += 1) {
  $forms[i].addEventListener("keydown", (event) => {
    if (
      event.key === "Enter" &&
      event.target.tagName.toUpperCase() !== "TEXTAREA" &&
      window.location.pathname !== "/login"
    ) {
      event.preventDefault();
    }
  });
}
